import classNames from 'classnames';
import * as React from 'react';
import css from './BaseLayout.module.scss';
import MerchantGlobalFooter from './MerchantGlobalFooter';
import GlobalNav from './GlobalNav/GlobalNav';
import PurchaseFlowMerchantHeader, {
  PurchaseFlowMerchantHeaderProps,
} from './PurchaseFlowMerchantHeader';

interface Props extends React.HTMLProps<{}> {
  merchantProps?: PurchaseFlowMerchantHeaderProps;
  logoImage: { url: string } | null;
  merchantPublicId: string | null;
  isCoubicApp: boolean;
  onFreePlan?: boolean;
}

const BaseLayoutMerchantWithShortHeader = (props: Props) => {
  return (
    <div className={classNames(css.BaseLayout, props.className)}>
      {!props.isCoubicApp && props.merchantProps && (
        <>
          <GlobalNav
            logoImage={props.logoImage}
            merchantPublicId={props.merchantPublicId}
            displayName={props.merchantProps?.displayName}
          />
          <PurchaseFlowMerchantHeader {...props.merchantProps} />
        </>
      )}
      {props.children}
      {!props.isCoubicApp && (
        <div className={css.BaseLayout__Footer}>
          <MerchantGlobalFooter
            merchantPublicId={props.merchantPublicId}
            onFreePlan={props.onFreePlan}
          />
        </div>
      )}
    </div>
  );
};

export default BaseLayoutMerchantWithShortHeader;
